/* angular:styles/component:css;257e87e5d8ee7c1f;/home/runner/work/app/app/src/app/components/notifications-nudge/notifications-nudge.component.ts */
:host {
  --crwd-notice-action-bg: var(--color-accent, #4c17ca);
}
/*# sourceMappingURL=notifications-nudge.component-ZHLJMNUT.css.map */
